export default {
  data() {
    return {
      loading: true,
    };
  },
  created() {
    if (!this.albumCategories) {
      this.$store.dispatch('SET_ALBUM_CATEGORIES');
    }
  },
};
